import { useEffect, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { useLanguage } from "../contexts/LanguageContext";

function Navbar() {
  const [userData, setUserData] = useState(null);
  const [t] = useTranslation("global");
  const { lang, setLang } = useLanguage();
  const navigate = useNavigate();
  console.log(lang);

  const handleChangeLang = () => {
    const newLang = lang === "en" ? "ar" : "en";
    setLang(newLang);
  };

  useEffect(() => {
    const storedUserData = JSON.parse(localStorage.getItem("userDataLogin"));
    if (storedUserData) {
      setUserData(storedUserData);
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("userDataLogin");
    setUserData(null);
    toast.success("Logged out successfully!");
    navigate("/");
  };
  const handleClick = () => {
    const userData = JSON.parse(localStorage.getItem("userDataLogin"));
    const userType = userData?.user?.type;
    const targetPath = userType === "student" ? "/profileDetails" : "/profile";
    navigate(targetPath);
  };
  return (
    <nav
      style={{ backgroundColor: "#fff" }}
      className="navbar container navbar-expand-md navbar-light"
    >
<Link to='/'>
<img
        style={{ width: "80px" }}
        src="/assets/imgs/logo3.png"
        alt="Logo"
      />
</Link>

      <button
        className="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon"></span>
      </button>

      <div className="collapse navbar-collapse" id="navbarSupportedContent">
        <ul className="navbar-nav mx-auto">
          <li className="nav-item">
            <NavLink className="nav-link mx-2" to="/">
              {t("header.home")} <span className="sr-only">(current)</span>
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link mx-2" to="/courses">
              {t("header.courses")}
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link mx-2" to="/instructors">
              {t("header.inustructos")}
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link mx-2" to="/about-us">
              {t("header.about")}
            </NavLink>
          </li>
        </ul>

        <div className="border rounded mx-2 p-2">
          <p className="m-0" onClick={handleChangeLang} style={{ cursor: "pointer" }}>
            {lang === "en" ? "AR" : "EN"}
          </p>
        </div>

        <div className="my-2 my-lg-0">
          {userData ? (
            <div className="dropdown">
              <button
                className="btn dropdown-toggle"
                type="button"
                id="dropdownMenuButton"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                {userData.user.name || "Profile"}{" "}
              </button>
              <ul
                className="dropdown-menu"
                aria-labelledby="dropdownMenuButton"
              >
                <li onClick={handleClick}>
                  <NavLink className="dropdown-item">{t("header.profile")}</NavLink>
                </li>

                <li>
                  <button onClick={handleLogout} className="dropdown-item">
                     {t("header.logout")}
                  </button>
                </li>
              </ul>
            </div>
          ) : (
            <NavLink to="/register">
              <button className="btn bg-btn my-2 my-sm-0">
                {t("header.sign")}
              </button>
            </NavLink>
          )}
        </div>

        {/**** <div className="d-flex">
          <div>
            <img
              style={{
                width: "50px",
                maxWidth: "100%",
                height: "50px",
                maxHeight: "100%",
                borderRadius: "50%",
              }}
              src="assets/imgs/Frame 1410103796.svg"
              alt="Profile"
            />
          </div>
          <ul className="navbar-nav">
            <li className="nav-item dropdown">
              <NavLink
                className="nav-link dropdown-toggle"
                to="#"
                id="navbarDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Ahmed ali
              </NavLink>
              <div className="dropdown-menu m-0" aria-labelledby="navbarDropdown">
                <NavLink className="dropdown-item" to="/logout">
                  <i className="fa fa-sign-out mx-2" aria-hidden="true"></i>LogOut
                </NavLink>
              </div>
            </li>
          </ul>
        </div> **** */}
      </div>
    </nav>
  );
}

export default Navbar;
